<template>
  <f7-page>
    <div class="layoutTop"></div>
    <div class="main-content">
      <b-row>
        <b-col sm="12">
          <transition name="slide-fade-title" appear>
            <div class="homepageBaseline homepageBaselineText d-flex">
              {{ $t('Homepage.baseline') }}
              <br/>
              {{ $t('Homepage.all') }}
            </div>
          </transition>
        </b-col>
      </b-row>
      <b-row :style="(context === 'RTP') ? 'margin-top: 10%;' : 'margin-top: 4%;'">
        <b-col sm="12">
          <div v-for="lineData in data" :key="lineData.id">
            <homepage-grid-line
              v-if="lineData.context.includes(context)"
              :lineData="lineData">
            </homepage-grid-line>
          </div>
        </b-col>
      </b-row>
    </div>
  </f7-page>
</template>

<script>
import homepageGridLine from '@/components/Homepage/homepageGridLine.vue'
import buttonsData from '@/pages/user/data/homepageData.json'

export default {
  name: 'Homepage',
  components: {
    'homepage-grid-line': homepageGridLine
  },
  props: {
    context: {
      default: 'generic',
      type: String
    }
  },
  data () {
    return {
      data: buttonsData.buttons
    }
  },
  created () {
    this.$bus.emit('isOnHomepage', true)
    this.$$('.homepageNavbar').removeClass('deleteNavBar')
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: '',
      navTitle: '',
      returnUrl: ''
    })
  }
}
</script>
<style scoped>
  .page-content {
    height: auto !important;
  }
  .main-content {
    overflow-x: hidden;
  }
  .main-page-positionning {
    margin-top: 44px;
    margin-bottom: 44px;
  }
  .homepageBaseline {
    display: block !important;
    text-align: center;
    top: 10%;
  }
  .homepageBaselineText {
    margin-top: 2%;
    font-weight: bolder;
    font-size: 1.2rem;
    line-height: normal;
    color:#000000
  }
  @media (min-width:450px) {
    .homepageBaselineText {
      font-size: 2rem;
    }
  }
  @media (min-width:600px) {
  .homepageBaselineText {
    font-size: 2.5rem;
  }
}
@media (min-width:992px) {
  .main-page-positionning {
    margin-top: 100px;
    margin-bottom: 100px;
  }
  .homepageBaselineText {
    font-size: 2.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// Homepage.vue?5ae7a250